
    // 常量定义
const x_pi = 3.14159265358979324 * 3000.0 / 180.0;
const pi = 3.1415926535897932384626;
const a = 6378245.0;  // 长半轴
const ee = 0.00669342162296594323;  // 扁率

// 辅助函数：判断是否在国内
function outOfChina(lng, lat) {
    return !(lng > 73.66 && lng < 135.05 && lat > 3.86 && lat < 53.55);
}

// 辅助函数：纬度转换
function transformLat(lng, lat) {
    let ret = -100.0 + 2.0 * lng + 3.0 * lat + 0.2 * lat * lat + 
              0.1 * lng * lat + 0.2 * Math.sqrt(Math.abs(lng));
    ret += (20.0 * Math.sin(6.0 * lng * pi) + 
            20.0 * Math.sin(2.0 * lng * pi)) * 2.0 / 3.0;
    ret += (20.0 * Math.sin(lat * pi) + 
            40.0 * Math.sin(lat / 3.0 * pi)) * 2.0 / 3.0;
    ret += (160.0 * Math.sin(lat / 12.0 * pi) + 
            320 * Math.sin(lat * pi / 30.0)) * 2.0 / 3.0;
    return ret;
}

// 辅助函数：经度转换
function transformLng(lng, lat) {
    let ret = 300.0 + lng + 2.0 * lat + 0.1 * lng * lng + 
              0.1 * lng * lat + 0.1 * Math.sqrt(Math.abs(lng));
    ret += (20.0 * Math.sin(6.0 * lng * pi) + 
            20.0 * Math.sin(2.0 * lng * pi)) * 2.0 / 3.0;
    ret += (20.0 * Math.sin(lng * pi) + 
            40.0 * Math.sin(lng / 3.0 * pi)) * 2.0 / 3.0;
    ret += (150.0 * Math.sin(lng / 12.0 * pi) + 
            300.0 * Math.sin(lng / 30.0 * pi)) * 2.0 / 3.0;
    return ret;
}

/**
 * WGS84转GCJ02(火星坐标)
 * @param {number} lng - WGS84经度
 * @param {number} lat - WGS84纬度
 * @returns {[number, number]} GCJ02坐标[经度, 纬度]
 */
function wgs84ToGcj02(lng, lat) {
    if (outOfChina(lng, lat)) {
        return [lng, lat];
    }
    
    let dlat = transformLat(lng - 105.0, lat - 35.0);
    let dlng = transformLng(lng - 105.0, lat - 35.0);
    
    const radlat = lat / 180.0 * pi;
    let magic = Math.sin(radlat);
    magic = 1 - ee * magic * magic;
    const sqrtmagic = Math.sqrt(magic);
    
    dlat = (dlat * 180.0) / ((a * (1 - ee)) / (magic * sqrtmagic) * pi);
    dlng = (dlng * 180.0) / (a / sqrtmagic * Math.cos(radlat) * pi);
    
    const mglat = lat + dlat;
    const mglng = lng + dlng;
    
    return [mglng, mglat];
}

/**
 * GCJ02转BD09
 * @param {number} lng - GCJ02经度
 * @param {number} lat - GCJ02纬度
 * @returns {[number, number]} BD09坐标[经度, 纬度]
 */
function gcj02ToBd09(lng, lat) {
    const z = Math.sqrt(lng * lng + lat * lat) + 0.00002 * Math.sin(lat * x_pi);
    const theta = Math.atan2(lat, lng) + 0.000003 * Math.cos(lng * x_pi);
    
    const bd_lng = z * Math.cos(theta) + 0.0065;
    const bd_lat = z * Math.sin(theta) + 0.006;
    
    return [bd_lng, bd_lat];
}

/**
 * WGS84转BD09（两步转换）
 * @param {number} lng - WGS84经度
 * @param {number} lat - WGS84纬度
 * @returns {[number, number]} BD09坐标[经度, 纬度]
 */
function wgs84ToBd09(lng, lat) {
    // 第一步：WGS84 -> GCJ02
    const gcj02 = wgs84ToGcj02(lng, lat);
    // 第二步：GCJ02 -> BD09
    return gcj02ToBd09(gcj02[0], gcj02[1]);
}

// 可选：BD09转GCJ02（反向转换）
function bd09ToGcj02(lng, lat) {
    const x = lng - 0.0065;
    const y = lat - 0.006;
    const z = Math.sqrt(x * x + y * y) - 0.00002 * Math.sin(y * x_pi);
    const theta = Math.atan2(y, x) - 0.000003 * Math.cos(x * x_pi);
    
    const gg_lng = z * Math.cos(theta);
    const gg_lat = z * Math.sin(theta);
    
    return [gg_lng, gg_lat];
}

// 可选：批量转换函数
function batchConvertWgs84ToBd09(coordinates) {
    return coordinates.map(coord => {
        return wgs84ToBd09(coord.lng, coord.lat);
    });
}
export {
   wgs84ToBd09
}


// WEBPACK FOOTER //
// ./src/components/BaiduMap/geo_conversion.js